import { Outlet } from "react-router-dom";

export function SettingsPage() {
  return <Outlet />;
}
